export default __webpack_public_path__ + "static/media/iconfont.ee37bac2.eot";